import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import {
  Button,
  FormGroup,
  Label,
  Input,
  Container,
  Row,
  Col,
  Card,
  CardBody,

} from 'reactstrap';
import * as Yup from 'yup';

import { forgotPassWord, resetPassword, getCaptchCode } from '../../store/page/auth/authThunk';
import loginLeft from "../../assets/images/project-img/login-side-img.svg"
import loginLogo from "../../assets/images/project-img/login-right-logo.svg"

const ForgotPassword = ({ onNext }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [resetToken, setResetToken] = useState(queryParams.get('token') || '');
  const [emailSent, setEmailSent] = useState(Boolean(queryParams.get('token')));
  const [submittedEmail, setSubmittedEmail] = useState(queryParams.get('email') || '',);
  const [captcha, setCaptcha] = useState('');
  const [captchaId, setCaptchaId] = useState('');
  const [captchaInput, setCaptchaInput] = useState('');
  const [captchaError, setCaptchaError] = useState('');
  const emailValidationSchema = Yup.object({
    email: Yup.string().email('Invalid email format').required('Email is required'),
  });

  const getCaptch = async () => {
    try {
      const resp = await dispatch(getCaptchCode()).unwrap();
      const captchaData = resp?.data || resp;
      setCaptcha(captchaData?.captcha || captchaData?.captchaCode || '');
      setCaptchaId(
        captchaData?.captchaId ||
          captchaData?.captcha_id ||
          captchaData?.captchid ||
          '',
      );
      setCaptchaError('');
    } catch (error) {
      setCaptcha('');
      setCaptchaId('');
      setCaptchaError(typeof error === 'string' ? error : 'Failed to load captcha');
    }
  };

  const refreshCaptcha = async () => {
    await getCaptch();
    setCaptchaInput('');
  };

  useEffect(() => {
    getCaptch();
  }, []);

  const passwordValidationSchema = Yup.object({
    password: Yup.string()
      .min(8, 'Password must be at least 8 characters')
      .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
      .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
      .matches(/[0-9]/, 'Password must contain at least one number')
      .matches(/[^A-Za-z0-9]/, 'Password must contain at least one special character')
      .required('Password is required'),

    confirm_password: Yup.string()
      .oneOf([Yup.ref('password')], 'Passwords must match')
      .required('Confirm password is required'),
  });

  return (
    <div className='login-page'>
      <div className='login-grid'>
      <div className='login-page-left-side'>
        <img src={loginLeft} alt='' />
      </div>
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: '100vh' }}
    >
      <Row className="w-100 login-form">
         <div className='d-flex justify-content-center mb-3'>
          <img src={loginLogo} alt='logo' />
        </div>
        <Col md={6} lg={7} className="mx-auto">
          <Card>
           

            <CardBody>
               <div className='text-center card-head'>
                <h1>Forgot Password</h1>
                {/* <p>Enter Your Email Id.</p> */}
              </div>
              {!emailSent ? (
                <Formik
                  initialValues={{ email: '' }}
                  validationSchema={emailValidationSchema}
                  onSubmit={async (values, { setSubmitting }) => {
                    const enteredCaptcha = captchaInput.trim().toUpperCase();
                    const generatedCaptcha = String(captcha).trim().toUpperCase();

                    if (!captchaId) {
                      setCaptchaError('Captcha is not available. Please refresh and try again.');
                      setSubmitting(false);
                      return;
                    }

                    if (!enteredCaptcha || enteredCaptcha !== generatedCaptcha) {
                      setCaptchaError('Captcha does not match.');
                      setSubmitting(false);
                      return;
                    }

                    try {
                      const response = await dispatch(
                        forgotPassWord({
                          email: values.email,
                          captchaId,
                          captcha: captchaInput,
                        }),
                      ).unwrap();
                      const apiToken =
                        response?.token ||
                        response?.reset_token ||
                        response?.data?.token ||
                        response?.data?.reset_token;

                      if (!apiToken) {
                        toast.success('Mail sent please check your mail');
                        return;
                      }

                      setSubmittedEmail(values.email);
                      localStorage.setItem('resetEmail', values.email);
                      setResetToken(apiToken);
                      setEmailSent(true);
                      toast.success('Mail sent please check your mail');
                      if (onNext) onNext(values.email);
                    } catch (error) {
                      toast.error(typeof error === 'string' ? error : 'Failed to send mail');
                    } finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {({ isSubmitting }) => (
                    <Form>
                      <FormGroup>
                        <Label>Email</Label> <span className="text-danger">*</span>
                        <Field as={Input} type="email" name="email" placeholder="Enter your email" />
                        <ErrorMessage name="email" component="div" className="text-danger" />
                      </FormGroup>
                      <FormGroup>
                            <Label>Captcha</Label>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px',}}>
                              <div
                                style={{ width: '130px', padding: '8px', background: '#e9e9e9',
                                  border: '2px dashed #888', borderRadius: '6px', fontSize: '20px',
                                  fontWeight: '700', letterSpacing: '4px', textAlign: 'center', fontFamily: 'monospace',
                                }}>{captcha}</div>
                              <Button type="button" color="info" onClick={refreshCaptcha}> ↻ </Button>
                            </div>

                            <Input type="text" placeholder="Enter captcha" value={captchaInput}
                              maxLength={5}
                              onChange={(e) => {
                                setCaptchaInput(e.target.value.toUpperCase());
                                setCaptchaError('');
                              }}
                              className="mt-2"
                            />

                            {captchaError && (
                              <div className="text-danger mt-1">
                                {captchaError}
                              </div>
                            )}
                          </FormGroup>
                      <Button color="primary" block type="submit" disabled={isSubmitting} className="login-button">
                        {isSubmitting ? 'Sending...' : 'Submit'}
                      </Button>
                    </Form>
                  )}
                </Formik>
              ) : (
                <Formik
                  initialValues={{ email: submittedEmail, password: '', confirm_password: '' }}
                  validationSchema={passwordValidationSchema}
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      await dispatch(
                        resetPassword({
                          email: submittedEmail,
                          password: values.password,
                          confirm_password: values.confirm_password,
                          token: resetToken,
                        }),
                      ).unwrap();
                      toast.success('Password reset successfully');
                      navigate('/auth/login');
                    } catch (error) {
                      const errorMessage =
                        error?.error ||
                        'Failed to reset password';
                      toast.error(errorMessage);
                    } finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {({ isSubmitting }) => (
                    <Form>
                      <FormGroup>
                        <Label>Email</Label>
                        <Field as={Input} type="email" name="email" disabled />
                      </FormGroup>
                      <FormGroup>
                        <Label>Password</Label> <span className="text-danger">*</span>
                        <Field as={Input} type="password" name="password" placeholder="Enter your new password" />
                        <ErrorMessage name="password" component="div" className="text-danger" />
                      </FormGroup>
                      <FormGroup>
                        <Label>Confirm Password</Label> <span className="text-danger">*</span>
                        <Field as={Input} type="password" name="confirm_password" placeholder="Confirm your new password" />
                        <ErrorMessage name="confirm_password" component="div" className="text-danger" />
                      </FormGroup>
                      <Button color="primary" block type="submit" disabled={isSubmitting} className="login-button">
                        {isSubmitting ? 'Updating...' : 'Update Password'}
                      </Button>
                    </Form>
                  )}
                </Formik>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    </div>
  );
};

// ✅ Prop validation (fixes ESLint warning)
ForgotPassword.propTypes = {
  onNext: PropTypes.func,
};

export default ForgotPassword;